import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import { h3Regular } from "../typography/MuiTypography.style";

export const LanguageSelectionWrapper = styled.div`
  .header-language-select {
    width: 160px;
    margin-top: 0;

    ${responsive.MOBILE`
      width: 98px;

      > div {
      justify-content: center;
    }
    `}
    .mui-select {
      background-color: ${COLORS.primary_light_blue2};
      & fieldset {
        border: none;
      }
      .MuiSelect-icon {
        display: none;
      }
    }

    .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {
      ${h3Regular}
      width: 100%;
      padding: 8px 16px;
      color: ${COLORS.cirrus_black};
      display: flex;
      align-items: center;
      ${responsive.MOBILE`
        padding: 8px;
        width:90%;
      `}
    }

    .MuiOutlinedInput-root.Mui-focused {
      background-color: ${COLORS.primary_light_blue4};
      border-color: ${COLORS.primary_light_blue4};
    }

    .MuiOutlinedInput-root:hover {
      background-color: ${COLORS.primary_light_blue3};
      border-color: ${COLORS.primary_light_blue4};
    }
  }
`;
